import workspaceQuery from 'graphql/queries/supplier/PurchaseOpeningBalanceWorkspaceQuery.graphql';
import instanceQuery from 'graphql/queries/supplier/PurchaseOpeningBalanceQuery.graphql';
import defaultQuery from 'graphql/queries/supplier/PurchaseOpeningBalanceDefault.graphql';
import mutationQuery from 'graphql/mutations/supplier/PurchaseOpeningBalanceMutation.graphql';
import temporaryMutationQuery from 'graphql/mutations/supplier/SavePurchaseOpeningBalanceTempMutation.graphql';
import fragment from 'graphql/fragments/supplier/PurchaseOpeningBalanceFragment.graphql';

import { formActions } from 'actions/supplier/PurchaseOpeningBalanceAction';

const PurchaseOpeningBalance = {
  type: 'PurchaseOpeningBalance',
  title: 'Supplier Opening Balances',
  formUrl: '/Suppliers/OpeningBalance/Details/',
  formTitle: 'Supplier Opening Balances',
  workspaceUrl: '/Suppliers/OpeningBalance/Workspace/',
  instance: instanceQuery,
  workspace: workspaceQuery,
  default: defaultQuery,
  update: mutationQuery,
  temporarySave: temporaryMutationQuery,
  fragment,
  screenReference: 'SUPPLIER_OPENING_BALANCES',
  actions: formActions,
  readOnlyStatus: [
    {
      key: 'documentStatus',
      status: ['POSTED'],
    },
  ],
};

export default PurchaseOpeningBalance;
